import { transportationKeys } from '../../../../../../../../consts/conditions';
import classNames from 'classnames';
import ConditionalInput from '../../ConditionalInput';
import AddFilterBtn from '../../AddFilterBtn';
import React, { useMemo } from 'react';

import {
  ArithmeticBody,
  ArithmeticContainer,
  ArithmeticFormulaStyled,
  ArithmeticWrapper,
  Form
} from './style';
import { ArithmeticFormula } from './components/ArithmeticFormula';
import { ArithmeticForm } from './components/ArithmeticForm';
import { Box, Button, Checkbox, Flex, rem, Text } from '@mantine/core';
import { IoGridOutline, IoTrash } from 'react-icons/io5';

export const Arithmetic = ({
  item,
  onChangeThen,
  onSelectItem,
  columns,
  isChildrenGroup,
  cuurentItem,
  filterTypes,
  parentFilterTypeId,
  onDeleteSelectedItems,
  addCondition,
  selectedItems,
  onChangeInputType,
  onChangeInput
}) => {
  const filterTypeId = filterTypes?.[0]?.id;

  const hasSelectedValue = useMemo(() => {
    let foundValue = false;
    filterTypes?.forEach(type => {
      type?.conditions?.forEach(condition => {
        if (condition?.value?.[condition?.inputType] || condition.type === 'group') {
          foundValue = true;
        }
      });
    });
    return foundValue;
  }, [filterTypes]);

  const isConcatenate = filterTypes?.[0]?.label === transportationKeys.CONCATENATE;
  const showFormula = !isChildrenGroup && hasSelectedValue && !isConcatenate;

  return (
    <ArithmeticContainer id="grid-table-arithmetic-root">
      {!isChildrenGroup && (
        <div>
          {selectedItems?.length > 0 && (
            <Flex id="grid-table-arithmetic-actions" gap={rem(8)} justify="flex-end">
              {!isConcatenate && (
                <Button
                  id="grid-table-arithmetic-group"
                  size="sm"
                  disabled={!selectedItems?.length > 0}
                  onClick={() => addCondition(item.id, 'group', filterTypeId)}
                  variant="transparent"
                  leftSection={<IoGridOutline />}
                >
                  Make Group
                </Button>
              )}

              <Button
                id="grid-table-arithmetic-delete"
                size="sm"
                disabled={!selectedItems?.length > 0}
                onClick={() => onDeleteSelectedItems(filterTypeId)}
                variant="transparent"
                leftSection={<IoTrash />}
                c="red.6"
              >
                Delete
              </Button>
            </Flex>
          )}
        </div>
      )}

      {showFormula && (
        <>
          <Box
            id="grid-table-arithmetic-formula-banner"
            bg="#F1F3F5"
            p="8px 12px"
            mb={rem(16)}
            style={{ borderRadius: '4px' }}
          >
            <Text id="grid-table-arithmetic-formula-label" c="#ADB5BD" fs={rem(14)}>
              Formula Builder
            </Text>
          </Box>

          <ArithmeticFormulaStyled id="grid-table-arithmetic-formula">
            <ArithmeticFormula filterType={filterTypes[0]} />
          </ArithmeticFormulaStyled>
        </>
      )}

      <div
        id="grid-table-arithmetic-card"
        className={classNames('filter_card', {
          ['noBorderBottom']: true,
          ['noBorderTop']: true,
          ['isDisableBefore']: true
        })}
      >
        <ArithmeticBody isChild={isChildrenGroup} isConcatenate={isConcatenate}>
          {parentFilterTypeId && (
            <div className={classNames('checkbox_line', 'with_line')}>
              <Checkbox
                id={`grid-table-arithmetic-parent-checkbox-${cuurentItem?.id}`}
                size={rem(16)}
                checked={selectedItems?.includes(cuurentItem?.id)}
                onClick={() => onSelectItem(cuurentItem?.id)}
              />
            </div>
          )}

          <div
            id="grid-table-arithmetic-box"
            className={classNames('box', { ' child': isChildrenGroup })}
          >
            <ArithmeticWrapper id="grid-table-arithmetic-wrapper">
              <Form
                id="grid-table-arithmetic-form"
                style={{
                  borderRadius: isChildrenGroup && '4px',
                  background: isChildrenGroup && 'transparent'
                }}
              >
                {item?.conditions?.map((el, idx) =>
                  el.conditions?.length > 0 ? (
                    <Arithmetic
                      key={idx}
                      item={el}
                      onChangeThen={onChangeThen}
                      onSelectItem={onSelectItem}
                      columns={columns}
                      isChildrenGroup={true}
                      cuurentItem={el}
                      filterTypes={filterTypes}
                      onDeleteSelectedItems={onDeleteSelectedItems}
                      addCondition={addCondition}
                      selectedItems={selectedItems}
                      onChangeInputType={onChangeInputType}
                      onChangeInput={onChangeInput}
                      parentFilterTypeId={item?.id}
                    />
                  ) : (
                    <ArithmeticForm
                      key={el?.id}
                      formIndex={idx}
                      type={el.type}
                      actionType={el.actionItem}
                      conditons={el.conditions}
                      columns={columns}
                      hasFirstElement={idx === 0}
                      operator={el.operator}
                      onSelect={() => onSelectItem(el.id)}
                      isSelected={selectedItems.includes(el.id)}
                      valueType={el?.inputType}
                      errors={el?.errors}
                      isConcatenate={isConcatenate}
                      onChangeValueType={val => onChangeInputType(filterTypeId, el?.id, val)}
                      onChangeValue={val => onChangeInput(filterTypeId, el?.id, val)}
                      value={el?.value?.[el?.inputType]}
                    />
                  )
                )}
              </Form>
            </ArithmeticWrapper>

            <AddFilterBtn
              id={`grid-table-arithmetic-add-${(cuurentItem || item).id}`}
              hideGroupBtn={isConcatenate}
              onClick={type => addCondition((cuurentItem || item).id, type, filterTypeId)}
            />
          </div>

          {!isChildrenGroup && (
            <div id="grid-table-arithmetic-result" className="result">
              {item.errors?.includes('then') ? (
                <label id="grid-table-arithmetic-result-label-required">
                  Result Column<span className="required">- Required</span>
                </label>
              ) : (
                <label id="grid-table-arithmetic-result-label">
                  Result Column<span className="required">*</span>
                </label>
              )}

              <ConditionalInput
                id="grid-table-arithmetic-result-input"
                type="column"
                placeholder="Select Column"
                columns={columns}
                required={true}
                hasRequiredError={item.errors?.includes('then')}
                onChangeValue={val => onChangeThen(filterTypeId, item?.id, val)}
                value={item?.then?.column}
                hiddenVariants={['column', 'null', 'input', 'ai_input']}
              />
            </div>
          )}
        </ArithmeticBody>
      </div>
    </ArithmeticContainer>
  );
};
